import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import CreateEvaluationCriteria from "Administrator/commonComponents/AssessmentSettingsEvaluationCriteria/routes/CreateEvaluationCriteria";
import MapEvaluationCriteria from "Administrator/commonComponents/AssessmentSettingsEvaluationCriteria/routes/MapEvaluationCriteria";
import EvaluationCriteriaSettings from "Administrator/commonComponents/AssessmentSettingsEvaluationCriteria/routes/EvaluationCriteriaSettings";

export default store => ({
  path: "evaluation-criteria-setup",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    CreateEvaluationCriteria(store),
    MapEvaluationCriteria(store),
    EvaluationCriteriaSettings(store),
  ],
});
